import { Observable } from 'rxjs';
import { WizardStepMeta } from '../interfaces/wizard-step';
import { WizardStepTracker } from '../interfaces/wizard-step-tracker';
import { WizardStateMachineInterface } from '../interfaces/wizard-state-machine';

export function useStateMachine({
  steps = [],
  getInitialPath
}: {
  steps: WizardStepMeta[];
  getInitialPath: (stepTracker: WizardStepTracker) => string | Observable<string> | Promise<string>;
}): WizardStateMachineInterface {
  return {
    steps,
    queryParamKey: 'wizard_step',
    getInitialPath,
    getStepFromPath: (path: string) => {
      return steps.find(step => step.path === path);
    }
  };
}
